module.exports = __webpack_public_path__ + "img/f_f_business_42_s512_f_business_42_0nbg.7eff2bb3.png";